import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { authAPI, systemAPI } from '../services/api';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';
import { HiOutlineMail, HiOutlineArrowLeft } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { IOSButton } from '../components/ios';

function MobileVerifyEmail() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [version, setVersion] = useState('');
  const email = location.state?.email || '';

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await systemAPI.getVersion();
        setVersion(response.data.version);
      } catch (error) {
        setVersion('1.4.1');
      }
    };
    fetchVersion();

    if (!email) {
      navigate('/login');
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!code || code.length !== 6) {
      toast.error(t('auth.enterVerificationCode'));
      return;
    }

    setLoading(true);
    try {
      const response = await authAPI.verifyEmail(email, code);
      localStorage.setItem('token', response.data.access_token);
      toast.success(t('auth.emailVerified'));
      navigate('/dashboard');
      window.location.reload();
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setResending(true);
    try {
      await authAPI.resendVerificationCode(email);
      toast.success(t('auth.codeResent'));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="mobile-auth-page">
      {/* Back button */}
      <button 
        className="mobile-auth-back"
        onClick={() => navigate('/login')}
      >
        <HiOutlineArrowLeft />
      </button>

      {/* Header */}
      <div className="mobile-auth-header">
        <h1>My Series</h1>
        <p>{t('auth.verifyEmailSubtitle')}</p>
      </div>

      {/* Email icon */}
      <div className="mobile-auth-icon-large">
        <HiOutlineMail />
      </div>

      {/* Email info */}
      <div className="mobile-auth-info">
        <p>{t('auth.checkYourEmail')}</p>
        <p className="mobile-auth-email">{email}</p>
      </div>

      {/* Formulário */}
      <form className="mobile-auth-form" onSubmit={handleSubmit}>
        <div className="mobile-auth-field">
          <label>{t('auth.verificationCode')}</label>
          <input
            type="text"
            className="mobile-auth-code-input"
            placeholder="000000"
            value={code}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              if (value.length <= 6) {
                setCode(value);
              }
            }}
            disabled={loading || resending}
            maxLength={6}
            inputMode="numeric"
            autoComplete="one-time-code"
          />
        </div>

        <IOSButton
          type="submit"
          variant="primary"
          fullWidth
          disabled={loading || resending || code.length !== 6}
          className="mobile-auth-submit"
        >
          {loading ? t('auth.verifying') : t('auth.verify')}
        </IOSButton>

        <button
          type="button"
          onClick={handleResendCode}
          disabled={loading || resending}
          className="mobile-auth-link"
        >
          {resending ? t('auth.resendingCode') : t('auth.resendCode')}
        </button>
      </form>

      {/* Versão */}
      <div className="mobile-auth-version">
        <p>{t('auth.copyright')}</p>
        <p>{t('common.version')} {version}</p>
      </div>
    </div>
  );
}

export default MobileVerifyEmail;
